
            import { injectStyle } from "__style_helper__"
            import css from "src/common/styles/global.css"
            injectStyle(css)
          